/* Himer Mayorista — theme.js
   Lucide init, AJAX cart, quantity stepper, FAQ accordion, product tabs. */
(function () {
  'use strict';

  /* ---- Lucide icons ---- */
  function initIcons() {
    if (window.lucide && window.lucide.createIcons) {
      window.lucide.createIcons();
    }
  }

  /* ---- Quantity stepper ---- */
  function initSteppers() {
    document.querySelectorAll('[data-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-stepper-input]');
      var minus = stepper.querySelector('[data-stepper-minus]');
      var plus = stepper.querySelector('[data-stepper-plus]');
      var min = parseInt(stepper.dataset.min || '1', 10);
      if (!input) return;
      if (minus) {
        minus.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10);
          if (v > min) {
            input.value = v - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10);
          input.value = v + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!btn || !answer) return;
      answer.style.display = 'none';
      btn.addEventListener('click', function () {
        var isOpen = answer.style.display !== 'none';
        answer.style.display = isOpen ? 'none' : 'block';
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ---- Product tabs ---- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      var buttons = tabs.querySelectorAll('[data-tab-btn]');
      var panels = tabs.querySelectorAll('[data-tab-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tabBtn;
          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.style.borderBottom = b === btn
              ? '2px solid var(--brand-primary)'
              : '2px solid transparent';
            b.style.color = b === btn ? 'var(--brand-primary)' : 'var(--text-body)';
          });
          panels.forEach(function (p) {
            p.style.display = p.dataset.tabPanel === target ? 'block' : 'none';
          });
        });
      });
    });
  }

  /* ---- AJAX cart (add to cart + drawer) ---- */
  var FREE_SHIPPING_THRESHOLD = 50000; // $50.000 CLP

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '$0';
    var amount = (cents / 100).toLocaleString('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return '$' + amount;
  }

  function initAjaxCart() {
    document.querySelectorAll('[data-ajax-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.style.opacity = '0.6';
          submitBtn.disabled = true;
        }
        /* Build JSON payload from form data */
        var variantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity') || '1', 10);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity }),
        })
          .then(function () {
            return fetch('/cart.js', {
              headers: { 'Accept': 'application/json' },
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartBadge(cart.item_count, cart.total_price);
            renderCartDrawer(cart);
            openCartDrawer();
            if (submitBtn) {
              submitBtn.style.opacity = '';
              submitBtn.disabled = false;
            }
          })
          .catch(function (err) {
            console.error('[himer] cart error:', err);
            /* Fallback: redirect to cart page */
            window.location.href = '/cart';
          });
      });
    });
  }

  function updateCartBadge(count, total) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
    var totals = document.querySelectorAll('[data-cart-total]');
    totals.forEach(function (t) {
      t.textContent = formatMoney(total);
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.removeAttribute('hidden');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.setAttribute('hidden', '');
    }
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var empty = document.querySelector('[data-cart-drawer-empty]');
    var footer = document.querySelector('[data-cart-drawer-footer]');
    var countEl = document.querySelector('[data-cart-drawer-count]');
    var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
    var shippingFill = document.querySelector('[data-shipping-fill]');
    var shippingText = document.querySelector('[data-shipping-text]');
    var shippingBar = document.querySelector('[data-shipping-bar]');

    if (!body) return;

    // Count
    if (countEl) {
      countEl.textContent = cart.item_count + ' artículo' + (cart.item_count !== 1 ? 's' : '');
    }

    // Subtotal
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Free shipping bar
    if (shippingFill && shippingText) {
      var progress = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);
      shippingFill.style.width = progress + '%';
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
        shippingText.innerHTML = '✓ ¡Tienes envío gratis!';
        shippingText.style.color = 'var(--brand-secondary)';
        shippingText.style.fontWeight = '700';
      } else {
        var remaining = formatMoney(FREE_SHIPPING_THRESHOLD - cart.total_price);
        shippingText.innerHTML = 'Te faltan <strong>' + remaining + '</strong> para envío gratis';
        shippingText.style.color = '';
        shippingText.style.fontWeight = '';
      }
    }

    if (cart.item_count === 0) {
      body.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      if (footer) footer.setAttribute('hidden', '');
      if (shippingBar) shippingBar.setAttribute('hidden', '');
      return;
    }

    if (empty) empty.setAttribute('hidden', '');
    if (footer) footer.removeAttribute('hidden');
    if (shippingBar) shippingBar.removeAttribute('hidden');

    // Render items
    var html = '';
    cart.items.forEach(function (item) {
      var imageHtml = '';
      if (item.image) {
        var imgUrl = item.image.replace('.jpg', '_72x72.jpg').replace('.png', '_72x72.png');
        if (imgUrl.indexOf('?') === -1) {
          imgUrl += '?width=72&height=72';
        }
        imageHtml = '<img class="cart-drawer__item-image" src="' + imgUrl + '" alt="' + escapeAttr(item.title) + '" width="72" height="72" loading="lazy">';
      } else {
        imageHtml = '<div class="cart-drawer__item-image-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 10V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h7"/><path d="M16 11l4 4-4 4"/></svg></div>';
      }

      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      var vid = item.variant_id;
      var unitPrice = item.price; // cents per unit
      html += '<div class="cart-drawer__item" data-vid="' + vid + '" data-qty="' + item.quantity + '" data-unit-price="' + unitPrice + '">' +
        imageHtml +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
          variantHtml +
          '<div class="cart-drawer__item-bottom">' +
            '<div class="cart-drawer__item-qty">' +
              '<button type="button" class="cart-drawer__item-qty-btn" data-qty-minus data-vid="' + vid + '" aria-label="Disminuir">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
              '<span class="cart-drawer__item-qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__item-qty-btn" data-qty-plus data-vid="' + vid + '" aria-label="Aumentar">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="cart-drawer__item-right">' +
              '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '<button type="button" class="cart-drawer__item-remove" data-qty-remove data-vid="' + vid + '">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
                '<span>Eliminar</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;

    // Bind qty buttons
    console.log('[himer] binding qty buttons, minus:', body.querySelectorAll('[data-qty-minus]').length, 'plus:', body.querySelectorAll('[data-qty-plus]').length);
    body.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(parseInt(btn.dataset.vid, 10), -1); });
    });
    body.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(parseInt(btn.dataset.vid, 10), 1); });
    });
    body.querySelectorAll('[data-qty-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { removeItem(parseInt(btn.dataset.vid, 10)); });
    });
  }

  function changeQty(variantId, delta) {
    var item = document.querySelector('[data-vid="' + variantId + '"]');
    if (!item) return;
    var currentQty = parseInt(item.dataset.qty, 10);
    var newQty = currentQty + delta;
    if (newQty < 1) { removeItem(variantId); return; }

    /* Optimistic UI update — instant */
    var unitPrice = parseInt(item.dataset.unitPrice, 10);
    item.dataset.qty = newQty;
    item.querySelector('.cart-drawer__item-qty-value').textContent = newQty;
    item.querySelector('.cart-drawer__item-price').textContent = formatMoney(unitPrice * newQty);
    updateCartSummaryOptimistic(variantId, delta, unitPrice);

    /* Sync with server in background */
    updateLine(variantId, newQty);
  }

  function removeItem(variantId) {
    /* Optimistic remove */
    var item = document.querySelector('[data-vid="' + variantId + '"]');
    if (item) {
      var qty = parseInt(item.dataset.qty, 10);
      var unitPrice = parseInt(item.dataset.unitPrice, 10);
      item.style.opacity = '0';
      item.style.transition = 'opacity 0.2s ease';
      setTimeout(function () { item.remove(); }, 200);
      updateCartSummaryOptimistic(variantId, -qty, unitPrice);
    }
    updateLine(variantId, 0);
  }

  function updateCartSummaryOptimistic(variantId, qtyDelta, unitPrice) {
    var priceDelta = qtyDelta * unitPrice;

    /* Update subtotal */
    var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
    if (subtotalEl) {
      var currentText = subtotalEl.textContent.replace(/[^0-9]/g, '');
      var currentCents = parseInt(currentText, 10) * 100 || 0;
      subtotalEl.textContent = formatMoney(currentCents + priceDelta);
    }

    /* Update badge count */
    var countEl = document.querySelector('[data-cart-drawer-count]');
    if (countEl) {
      var match = countEl.textContent.match(/(\d+)/);
      if (match) {
        var newCount = parseInt(match[1], 10) + qtyDelta;
        if (newCount <= 0) {
          /* Will show empty state on server re-render */
          return;
        }
        countEl.textContent = newCount + ' artículo' + (newCount !== 1 ? 's' : '');
      }
    }

    /* Update header cart badge */
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      var match = b.textContent.match(/(\d+)/);
      if (match) {
        var c = parseInt(match[1], 10) + qtyDelta;
        b.textContent = c;
        b.style.display = c > 0 ? 'flex' : 'none';
      }
    });
  }

  function updateLine(variantId, quantity) {
    var updates = {};
    updates[variantId] = quantity;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count, cart.total_price);
        renderCartDrawer(cart);
      })
      .catch(function (err) { console.error('[himer] cart sync error:', err); });
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(str) { return escapeHtml(str); }

  function initCartDrawer() {
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    var closeBtn = document.querySelector('[data-cart-drawer-close]');
    var continueBtn = document.querySelector('[data-cart-drawer-continue]');

    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (continueBtn) continueBtn.addEventListener('click', closeCartDrawer);

    // Cart link in header opens drawer
    var cartLink = document.querySelector('.himer-cart-link');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            renderCartDrawer(cart);
            openCartDrawer();
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    }

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && drawer.classList.contains('is-open')) {
          closeCartDrawer();
        }
      }
    });

    // Initial render
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartBadge(cart.item_count, cart.total_price);
      })
      .catch(function () {});
  }

  /* ---- Init on DOM ready ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initIcons();
    initSteppers();
    initFaq();
    initTabs();
    initAjaxCart();
    initCartDrawer();
  });

  /* Re-init icons after Shopify section reloads */
  document.addEventListener('shopify:section:load', initIcons);
  document.addEventListener('shopify:section:select', initIcons);
})();
